import Icon from '../../../components/AppIcon';

const NextStepsCard = ({ steps }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
      <h3 className="text-sm font-bold text-slate-700 mb-4 flex items-center gap-2">
        <Icon name="ListChecks" size={15} className="text-primary" />
        الخطوات القادمة
      </h3>
      <div className="space-y-3">
        {steps?.map((step, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className={`w-6 h-6 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-bold mt-0.5 ${
              index === 0 ? 'bg-primary text-white' : 'bg-slate-100 text-slate-500'
            }`}>
              {index + 1}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-semibold text-slate-800">{step.title}</p>
                {step.timeline && (
                  <span className="text-[10px] text-slate-400 whitespace-nowrap flex-shrink-0">{step.timeline}</span>
                )}
              </div>
              <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NextStepsCard;
